import { render, staticRenderFns } from "./UserDetailEdit.vue?vue&type=template&id=328b694b&scoped=true&"
import script from "./UserDetailEdit.vue?vue&type=script&lang=js&"
export * from "./UserDetailEdit.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailEdit.vue?vue&type=style&index=0&id=328b694b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "328b694b",
  null
  
)

export default component.exports